import { NAME as PARENT_NAME } from '../constants';

export const NAME = `${PARENT_NAME}/HISTORY/CUSTOMER`;

export const REDUCER_NAME = 'historyCustomerWaybills';

export const LISTING_API = {
  LISTING: `${SHIPPING_EDGE}/public-api/waybills/history?domain=${SYSTEM_DOMAIN}`,
};

export const ROUTES = {
  ROOT: '/shipment/track/customer/:phone',
};
